import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-invite',
    templateUrl: './modal-invite.component.html',
    styleUrls: ['./modal-invite.component.scss'],
    standalone: false
})
export class ModalInviteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
